import React, { useCallback, useMemo } from 'react';
import { noop } from 'lodash';
import TextInput from '../../../webcommon/common/formcomponents/textinput/TextInput';
import PropTypes from 'prop-types';
import Dropdown from '../../../webcommon/common/formcomponents/dropdown/Dropdown';
import defaultStyles from './CustomFormComponent.module.scss';

const CustomFormComponent = (props) => {
    const {
        setActiveValue,
        isDropdown,
        readOnly,
        activeValue,
        placeholder,
        dropdownOptions,
        styles
    } = props;

    const setVal = useCallback((e) => {
        setActiveValue(e.target.value);
    }, [setActiveValue]);

    const component = useMemo(() => {
        if (isDropdown) {
            return (
                <Dropdown
                    onSelection={ setActiveValue }
                    options={ dropdownOptions }
                    placeholder=""
                    value={ activeValue }
                />
            );
        }
        if (readOnly) {
            return (
                <div className={ styles.readOnlyField }>
                    { activeValue }
                </div>
            );
        }
        return (
            <TextInput
                value={ activeValue }
                onChange={ setVal }
                placeholder={ placeholder }
            />
        );
    }, [
        isDropdown,
        readOnly,
        activeValue,
        placeholder,
        dropdownOptions,
        setActiveValue,
        styles.readOnlyField,
        setVal
    ]);

    return (
        <div className={ props.styles.formComponentWrapper }>
            <div className={ props.styles.formTitle }>
                {props.title}
            </div>
            { component }
        </div>
    );
};

CustomFormComponent.propTypes = {
    activeValue: PropTypes.string,
    dropdownOptions: PropTypes.arrayOf(PropTypes.string),
    isDropdown: PropTypes.bool,
    placeholder: PropTypes.string,
    setActiveValue: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string,
    readOnly: PropTypes.bool
};

CustomFormComponent.defaultProps = {
    activeValue: '',
    dropdownOptions: [],
    isDropdown: false,
    placeholder: '',
    setActiveValue: noop,
    styles: defaultStyles,
    title: '',
    readOnly: false
};

export default CustomFormComponent;
